import React from 'react'
import PropTypes from 'prop-types'
import RemoveableFile from '#components/m/RemoveableFile'

function NachweisListeReference(props) {
  const {nachweise, onNachweisRemove, isReadOnly} = props
  return (
    <div className="nachweisListeReference">
      {nachweise.map(nachweis => (
        <RemoveableFile nachweis={nachweis} key={nachweis.id} onRemove={onNachweisRemove} isReadOnly={isReadOnly} />
      ))}
    </div>
  )
}

NachweisListeReference.propTypes = {
  nachweise: PropTypes.arrayOf(
    PropTypes.shape({
      nummer: PropTypes.number,
    }),
  ).isRequired,
  onNachweisRemove: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool,
}

export default NachweisListeReference
